export default {
  pt: {
    'mapa.frotaImagem.abrir': 'Gerar imagem da frota',
    'mapa.frotaImagem.titulo': 'Imagem da Frota pesada',
    'mapa.frotaImagem.previewAlt': 'Prévia da imagem da Frota pesada',
    'mapa.frotaImagem.copiarImagem': 'Copiar imagem',
    'mapa.frotaImagem.baixarPng': 'Baixar PNG',
    'mapa.frotaImagem.imagemCopiada': 'Imagem da frota copiada.',
    'mapa.frotaImagem.copiaImagemFalhou': 'Não foi possível copiar a imagem. Use Baixar PNG.',
    'mapa.frotaImagem.baixarFalhou': 'Não foi possível gerar o PNG. Tente novamente.',
    'mapa.frotaImagem.copiaNaoSuportada': 'Este navegador não copia imagens. Use Baixar PNG.',
    'mapa.frotaImagem.semLinhas': 'Nenhum veículo na grade para gerar a imagem.',
    'mapa.frotaImagem.filtroBusca': 'Busca',
    'mapa.frotaImagem.col.placa': 'Placa',
    'mapa.frotaImagem.col.status': 'Status',
    'mapa.frotaImagem.col.motorista': 'Motorista',
    'mapa.frotaImagem.col.localAtual': 'Local atual',
    'mapa.frotaImagem.col.cerca': 'Cerca',
    'mapa.frotaImagem.col.temperatura': 'Temperatura',
    'mapa.frotaImagem.col.conexao': 'Conexão',
  },
  en: {
    'mapa.frotaImagem.abrir': 'Generate fleet image',
    'mapa.frotaImagem.titulo': 'Heavy fleet image',
    'mapa.frotaImagem.previewAlt': 'Heavy fleet image preview',
    'mapa.frotaImagem.copiarImagem': 'Copy image',
    'mapa.frotaImagem.baixarPng': 'Download PNG',
    'mapa.frotaImagem.imagemCopiada': 'Fleet image copied.',
    'mapa.frotaImagem.copiaImagemFalhou': 'Could not copy the image. Use Download PNG.',
    'mapa.frotaImagem.baixarFalhou': 'Could not generate the PNG. Try again.',
    'mapa.frotaImagem.copiaNaoSuportada': 'This browser cannot copy images. Use Download PNG.',
    'mapa.frotaImagem.semLinhas': 'No vehicles in the grid to generate the image.',
    'mapa.frotaImagem.filtroBusca': 'Search',
    'mapa.frotaImagem.col.placa': 'Plate',
    'mapa.frotaImagem.col.status': 'Status',
    'mapa.frotaImagem.col.motorista': 'Driver',
    'mapa.frotaImagem.col.localAtual': 'Current location',
    'mapa.frotaImagem.col.cerca': 'Geofence',
    'mapa.frotaImagem.col.temperatura': 'Temperature',
    'mapa.frotaImagem.col.conexao': 'Connection',
  },
  es: {
    'mapa.frotaImagem.abrir': 'Generar imagen de la flota',
    'mapa.frotaImagem.titulo': 'Imagen de la Flota pesada',
    'mapa.frotaImagem.previewAlt': 'Vista previa de la imagen de la Flota pesada',
    'mapa.frotaImagem.copiarImagem': 'Copiar imagen',
    'mapa.frotaImagem.baixarPng': 'Descargar PNG',
    'mapa.frotaImagem.imagemCopiada': 'Imagen de la flota copiada.',
    'mapa.frotaImagem.copiaImagemFalhou': 'No fue posible copiar la imagen. Use Descargar PNG.',
    'mapa.frotaImagem.baixarFalhou': 'No fue posible generar el PNG. Intente de nuevo.',
    'mapa.frotaImagem.copiaNaoSuportada': 'Este navegador no copia imágenes. Use Descargar PNG.',
    'mapa.frotaImagem.semLinhas': 'Ningún vehículo en la tabla para generar la imagen.',
    'mapa.frotaImagem.filtroBusca': 'Búsqueda',
    'mapa.frotaImagem.col.placa': 'Placa',
    'mapa.frotaImagem.col.status': 'Estado',
    'mapa.frotaImagem.col.motorista': 'Conductor',
    'mapa.frotaImagem.col.localAtual': 'Ubicación actual',
    'mapa.frotaImagem.col.cerca': 'Geocerca',
    'mapa.frotaImagem.col.temperatura': 'Temperatura',
    'mapa.frotaImagem.col.conexao': 'Conexión',
  },
}
